import * as React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltapro/h5/');
const App: React.FunctionComponent = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_new');
    const web1Map = {
        us: ['DELTAPRO_M_1.webp', 'DELTAPRO_M_1.png'],
        au: ['DELTAPRO_M_1_au.webp', 'DELTAPRO_M_1_au.png'],
        uk: ['DELTAPRO_M_1_uk.webp', 'DELTAPRO_M_1_uk.png'],
        de: ['DELTAPRO_M_1_eu.webp', 'DELTAPRO_M_1_eu.png'],
        fr: ['DELTAPRO_M_1_eu.webp', 'DELTAPRO_M_1_eu.png'],
        eu: ['DELTAPRO_M_1_eu.webp', 'DELTAPRO_M_1_eu.png'],
        it: ['DELTAPRO_M_1_eu.webp', 'DELTAPRO_M_1_eu.png'],
        es: ['DELTAPRO_M_1_eu.webp', 'DELTAPRO_M_1_eu.png'],
        kr: ['DELTAPRO_M_1_eu.webp', 'DELTAPRO_M_1_eu.png'],
        cis: ['DELTAPRO_M_1_eu.webp', 'DELTAPRO_M_1_eu.png'],
        jp: ['DELTAPRO_M_1_jp.webp', 'DELTAPRO_M_1_jp.png'],
        cn: ['DELTAPRO_M_1_cn.webp', 'DELTAPRO_M_1_cn.png'],
        za: ['DELTAPRO_M_1_za.webp', 'DELTAPRO_M_1_za.png'],
        sa: ['DELTAPRO_M_1_uk.webp', 'DELTAPRO_M_1_uk.png'],
    };

    return (
        <>
            <section className={`river-mini-overview ${css.OverView}`}>
                <article className="grid-content">
                    <div className="view-item view-item-1">
                        <EFPic name={web1Map[locale as keyof typeof web1Map] || web1Map['us']} alt={t('second_capacity')} aria-label={t('second_capacity')} />
                        <span className="text">
                            {t('second_capacity_value')}
                            <br />
                            {t('second_capacity')}
                        </span>
                    </div>
                    <div className="view-item view-item-2">
                        <EFPic name={['DELTAPRO_M_2.webp', 'DELTAPRO_M_2.png']} alt={t('second_ac_onput_value')} aria-label={t('second_ac_onput_value')} />
                        <span className="text">
                            {t('second_ac_onput_value')}
                            <br />
                            {t('second_ac_onput')}
                        </span>
                    </div>
                    <div className="view-item view-item-3">
                        <EFPic name={['DELTAPRO_M_3.webp', 'DELTAPRO_M_3.png']} alt={t('second_flow_charge')} aria-label={t('second_flow_charge')} />
                        <span
                            className="text"
                            dangerouslySetInnerHTML={{
                                __html: t('second_flow_charge'),
                            }}
                        ></span>
                    </div>
                    <div className="view-item view-item-4">
                        <EFPic
                            name={['DELTAPRO_M_4.webp', 'DELTAPRO_M_4.png']}
                            alt={t('second_multicharge_value')}
                            aria-label={t('second_multicharge_value')}
                        />
                        <span className="text">
                            {t('second_multicharge_value')}
                            <br />
                            {t('second_multicharge')}
                        </span>
                    </div>
                    <div className="view-item view-item-5">
                        <EFPic
                            name={['DELTAPRO_M_5.webp', 'DELTAPRO_M_5.png']}
                            alt={t('second_ev_station_charging')}
                            aria-label={t('second_ev_station_charging')}
                        />
                        <span className="text">{t('second_ev_station_charging')}</span>
                    </div>
                    <div className="view-item view-item-6">
                        <span className="text">{t('second_solar_input_no_html')}</span>
                    </div>
                    <div className="view-item view-item-7">
                        <span className="text">{t('second_lfp_battery_chemistry')}</span>
                    </div>
                    <div className="view-item view-item-8">
                        <EFPic name={['DELTAPRO_M_6.webp', 'DELTAPRO_M_6.png']} alt={t('Detachable')} aria-label={t('Detachable')} />
                        <span className="text">{t('second_expandable_ecosystem')}</span>
                    </div>
                </article>
            </section>
        </>
    );
};

export default App;
